<template>
	<div id="" ref="">
		<table class="CFTable" style="float:left; width:760px; margin-left:10px; margin-top:10px;" ref="idVerList"></table>
	</div>
</template>

<script>

export default {
	name: 'verSelect',
	components:{

	},
	data () {
		return {
			appId: "",
			devId: "",
			curVerno: "",
		}
	},
	mounted: function(){
		this.appId = this.$route.query.appId;
		this.devId = this.$route.query.devId;
		this.curVerno = this.$route.query.daCurVerno;

		this.getverList();
	},
	computed:{

	},
	methods:{
		getverList: function(){
			let body={ appId: this.appId };
			this.doTrade( "POST", ServAddr+"/api/app/verList", this.onVerListOK, true, body, null );
		},
		onVerListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			let obj=this.$refs["idVerList"];
			obj.innerHTML = "";
			let tr=null;
			let td=null;
			tr = document.createElement("tr");
			obj.appendChild( tr );
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("应用");
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("版本");
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("发布时间");
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("强制");
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("详情");
			td = document.createElement("th");  tr.appendChild(td);   td.innerText = LangText("操作");

			for( let i=0; i<data.body.verList.length; i++ )
			{
				let ver=data.body.verList[i];
				tr = document.createElement("tr");
				obj.appendChild( tr );
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.appName;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.appVerno;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = ver.avPublishDate;
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = this.getForceText(ver.avForce);
				td = document.createElement("td");  tr.appendChild(td);   td.innerText = "";
				td = document.createElement("td");  tr.appendChild(td);

				if( parseInt(this.curVerno) < parseInt(ver.appVerno) )
				{
					td.innerHTML = "[ <font class='OPItem'>"+LangText("选择")+"</font> ]";
					let that=this;
					td.onclick = function(){
						let body={ devId: that.devId, appId: that.appId, daUpdVerno: ver.appVerno };
						that.doTrade( "POST", ServAddr+"/api/device/devUpdSet", that.onUpdSetOK, true, body, null );
					};
				}
			}
		},
		onUpdSetOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.$parent.onPopWinClose( true, null );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// verSelect.vue?11162b7e